/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { DatasetImport } from '../types/dataset/DatasetImport';
import { DatasetImportStatus } from '../types/dataset/DatasetImportStatus';

export const getDatasetImportsWithStatus = (
  datasets: DatasetImport[],
  neededStatus: DatasetImportStatus[],
): DatasetImport[] => {
  return datasets.filter(d => neededStatus.indexOf(d.status) > -1);
};
